export const OK = 'ok';
export const GREEN = 'green';
export const RED = 'red';
export const INACTIVE = 'inactive';
